import { render, staticRenderFns } from "./Mastitis.vue?vue&type=template&id=4aa134fa&"
import script from "./Mastitis.vue?vue&type=script&lang=js&"
export * from "./Mastitis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports